module.exports = __webpack_public_path__ + "media/images/shared/suppliers/ZF_LEMFRDER-7c2e83e25aa80df7fd29ce7635681219.jpg";